import React, { useEffect } from 'react'
import { Button } from '@sainsburys-tech/fable'
import PropTypes from 'prop-types'
import BlackInfoIcon from '../../../assets/BlackInfoIcon.svg'

import '../../../sass/components/prevent-signout-modal.scss'

const PreventSignOutModal = (props) => {
  const {
    isOpen, handleClose, okClick, isPlural
  } = props

  useEffect(() => {
    if (!isOpen) return undefined

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        handleClose()
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [isOpen, handleClose])

  if (!isOpen) return null

  return (
    <div
      className="dsib-preventSignOutModalOverlay"
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) handleClose()
      }}
    >
      <div className="dsib-preventSignOutModalDialog" role="dialog" aria-modal="true" aria-label="Sign out">
        <div className="dsib-preventSignOutModalHeader">
          <h2 className="dsib-preventSignOutModalTitle">Sign out</h2>
          <button
            type="button"
            className="dsib-preventSignOutModalClose"
            onClick={handleClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="dsib-preventSignOutModalBody">
          <div className="dsib-preventSignOutModalWarning" role="alert">
            <img className="dsib-preventSignOutModalWarningIcon" src={BlackInfoIcon} alt="" aria-hidden="true" />
            <div className="dsib-preventSignOutModalWarningText">
              {`Your ${isPlural ? 'passes are' : 'pass is'} still open`}
            </div>
          </div>

          <p className="dsib-preventSignOutModalMessage">
            {`You need to hand back your ${isPlural ? 'passes' : 'pass'} before you sign out.`}
          </p>

          <div className="dsib-preventSignOutModalCta">
            <Button variant="primary" isFullWidth onClick={okClick}>OK</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

PreventSignOutModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  okClick: PropTypes.func.isRequired,
  isPlural: PropTypes.bool
}

PreventSignOutModal.defaultProps = {
  isPlural: false
}

export default PreventSignOutModal
